var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 9.84611,
    fill: "url(#paint0_linear_638_2338)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.09619,
    y: 1.09583,
    width: 37.8082,
    height: 37.8082,
    rx: 9.3066,
    fill: "url(#paint1_linear_638_2338)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_2338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8649 10.1329C28.978 9.24723 27.7758 8.74976 26.5223 8.74976C25.2688 8.74976 24.0666 9.24723 23.1796 10.1329L18.1884 15.1251C18.049 15.264 17.9385 15.4292 17.8632 15.611C17.7879 15.7928 17.7493 15.9877 17.7496 16.1845V17.7501H16.1718C15.8451 17.7509 15.5274 17.8575 15.2662 18.0539C15.2391 18.0746 15.2134 18.0971 15.1893 18.1214L14.4393 18.8714C14.3 19.0107 14.1895 19.176 14.1141 19.358C14.0387 19.54 13.9999 19.7351 13.9999 19.9321C13.9999 20.1292 14.0387 20.3242 14.1141 20.5062C14.1895 20.6883 14.3 20.8536 14.4393 20.9929L16.1924 22.747L8.9737 29.9704C8.90402 30.0401 8.84874 30.1228 8.81103 30.2139C8.77332 30.3049 8.75391 30.4025 8.75391 30.501C8.75391 30.5996 8.77332 30.6972 8.81103 30.7882C8.84874 30.8793 8.90402 30.962 8.9737 31.0317C9.11443 31.1724 9.3053 31.2515 9.50432 31.2515C9.60287 31.2515 9.70045 31.2321 9.7915 31.1943C9.88254 31.1566 9.96527 31.1014 10.0349 31.0317L17.2537 23.8073L19.0078 25.5614C19.289 25.8425 19.6704 26.0004 20.0681 26.0004C20.4657 26.0004 20.8471 25.8425 21.1284 25.5614L21.8784 24.8114C21.9026 24.787 21.9252 24.761 21.9459 24.7336C22.1434 24.473 22.2504 24.1549 22.2506 23.8279V22.2501H23.8153C24.0122 22.2505 24.2073 22.2117 24.3892 22.1361C24.571 22.0605 24.736 21.9494 24.8746 21.8095L29.8649 16.8192C30.304 16.3802 30.6522 15.859 30.8898 15.2853C31.1275 14.7117 31.2497 14.0969 31.2497 13.476C31.2497 12.8552 31.1275 12.2404 30.8898 11.6668C30.6522 11.0931 30.304 10.5719 29.8649 10.1329ZM27.2803 13.7789L22.0303 19.0289C21.8897 19.1696 21.6989 19.2487 21.5 19.2488C21.301 19.2489 21.1102 19.1699 20.9695 19.0293C20.8287 18.8887 20.7496 18.698 20.7495 18.499C20.7495 18.3001 20.8284 18.1093 20.969 17.9685L26.219 12.7186C26.3597 12.5778 26.5506 12.4988 26.7496 12.4988C26.9487 12.4988 27.1395 12.5778 27.2803 12.7186C27.421 12.8593 27.5001 13.0502 27.5001 13.2492C27.5001 13.4482 27.421 13.6391 27.2803 13.7798V13.7789Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_638_2338",
    x1: -11.5068,
    y1: -3.56164,
    x2: 41.3699,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_638_2338",
    x1: 12.5362,
    y1: 6.12088,
    x2: 38.9044,
    y2: 51.4098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.140376,
    stopColor: "#E8AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_2338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.00012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempering);
export default __webpack_public_path__ + "static/media/tempering.6c5c352d4dcd2ff48bbdfaf51769305c.svg";
export { ForwardRef as ReactComponent };